import React, { useMemo } from 'react';
import { Text } from '@moda/om';
import { ReturnPolicy } from '../../generated/types/globalTypes';
import { getReturnPolicy } from './getReturnPolicy';

export enum ShortReturnPolicyCopyApproach {
  Singular,
  Plural
}

export type ReturnableReturnPolicy =
  | ReturnPolicy.full_refund
  | ReturnPolicy.full_refund_markdown
  | ReturnPolicy.site_credit
  | ReturnPolicy.site_credit_markdown;

interface Props {
  returnPolicy: ReturnableReturnPolicy;
  promoCodeApplied: boolean;
  highlightDaysNumber?: boolean;
  approach?: ShortReturnPolicyCopyApproach;
}

export const ShortReturnPolicyCopy: React.FC<Props> = ({
  returnPolicy,
  promoCodeApplied,
  highlightDaysNumber = false,
  approach = ShortReturnPolicyCopyApproach.Plural
}) => {
  const { returnDaysNumber, refundMethod } = useMemo(
    () => getReturnPolicy(returnPolicy, promoCodeApplied),
    [promoCodeApplied, returnPolicy]
  );

  if (!returnDaysNumber) {
    return null;
  }

  return (
    <>
      {approach === ShortReturnPolicyCopyApproach.Singular && 'Item is returnable within'}

      {approach === ShortReturnPolicyCopyApproach.Plural && 'These items are returnable within'}

      <Text treatment={highlightDaysNumber ? 'bold1' : undefined}>
        {` ${returnDaysNumber} days`}
      </Text>

      {refundMethod ? ` for a ${refundMethod}.` : '.'}
    </>
  );
};
